<template>
  <div>
    <draggable
      v-model="local_value"
      class="drag-area synaplus-cosmo-scroll-higher-720"
      group="metavariables-dict-type"
      handle=".metavariables-dict-type-handle"
      :sort="editing_nb == -1"
    >
      <metavariables-dict-element
        v-for="(val, index) in local_value"
        v-bind="metavariables_dict_element_bindings(false, val, index)[0]"
        v-on="metavariables_dict_element_bindings(false, val, index)[1]"
        class="mt-2 hand-pointer metavariables-dict-type-handle"
      />
    </draggable>

    <metavariables-dict-element
      v-model="new_metavariables_dict_entry"
      v-bind="
        metavariables_dict_element_bindings(
          true,
          new_metavariables_dict_entry
        )[0]
      "
      v-on="
        metavariables_dict_element_bindings(
          true,
          new_metavariables_dict_entry
        )[1]
      "
      class="mt-4"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import draggable from 'vuedraggable'

import MetavariablesDictElement from '@/components/metavariables_dict_element.vue'

// *****************************************************************************

export default {
  name: 'ProjectAdminSubcomponentMetavariablesDictsEditor',
  components: {
    draggable,
    MetavariablesDictElement,
  },
  props: ['value', 'metavariables_types'],

  data() {
    return {
      local_value: undefined,
      editing_nb: -1,
      new_metavariables_dict_entry: {},
    }
  },

  computed: {
    _() {
      return _
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.local_value = _.cloneDeep(nv)
        }
      },
    },

    local_value(nv, ov) {
      if (!_.isEqual(nv, this.value)) {
        this.$emit('input', nv)
      }
    },
  },

  methods: {
    add_new_dict(entry) {
      if (!_.find(this.local_value, x => _.isEqual(x, entry))) {
        this.local_value.push(entry)
      }

      this.new_metavariables_dict_entry = {}
      this.editing_nb = -1
    },

    delete_metavariables_dict(index) {
      this.local_value.splice(index, 1)
      this.editing_nb = -1
    },

    validate_metavariables_dict_edition(index, entry) {
      Vue.set(this.local_value, index, entry)
      this.remove_potential_duplicate(index, entry)
    },

    remove_potential_duplicate(index, entry) {
      let temp = _.cloneDeep(this.local_value)
      temp.splice(index, 1)

      let duplicate_index = _.findIndex(temp, x => _.isEqual(x, entry))

      if (duplicate_index !== -1) {
        if (duplicate_index >= index) {
          duplicate_index += 1
        }
        this.local_value.splice(duplicate_index, 1)
      }

      this.editing_nb = -1
    },

    metavariables_dict_element_bindings(is_new_entry, entry, index) {
      let is_new_dict = is_new_entry
      let in_edition = is_new_entry ? true : this.editing_nb == index
      let metavariables_types = this.metavariables_types

      let bind = { value: entry, is_new_dict, in_edition, metavariables_types }

      let on = is_new_entry
        ? {
            input: this.add_new_dict.bind(this),
          }
        : {
            start_editing: () => {
              this.editing_nb = index
            },
            delete: () => this.delete_metavariables_dict(index),
            input: val => {
              this.validate_metavariables_dict_edition(index, val)
            },
          }

      let res = [bind, on]

      return res
    },
  },
}
</script>
